import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

import { BLACK, WHITE, PORCELAIN, OSLO_GRAY } from '@constant/colors';

const Browser = ({
  circles,
  className,
  domain,
  height,
  navBar,
  navBarText,
  subDomain,
  width,
}) => {
  const browserUrl = (
    <tspan x={navBarText.x} y={navBarText.y} fill={OSLO_GRAY}>
      <tspan fill={BLACK}>{subDomain}</tspan>.{domain}
    </tspan>
  );

  const svgClassName = ['browser'];
  if (className) {
    svgClassName.push(className);
  }

  return (
    <svg
      className={svgClassName.join(' ')}
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 313 214"
    >
      <defs>
        <rect id="browser-icon-a" width="310" height="210" rx="5" />
        <filter
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
          id="browser-icon-b"
        >
          <feOffset
            dx="3"
            dy="3"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.114583333 0"
            in="shadowOffsetOuter1"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="browser-icon-c" fill={WHITE}>
          <use xlinkHref="#browser-icon-a" />
        </mask>
        <use
          fill={BLACK}
          filter="url(#browser-icon-b)"
          xlinkHref="#browser-icon-a"
        />
        <use fill={PORCELAIN} xlinkHref="#browser-icon-a" />
        <path
          fill={OSLO_GRAY}
          mask="url(#browser-icon-c)"
          d="M0 40h470v280H0z"
        />
        <rect
          fill={WHITE}
          mask="url(#browser-icon-c)"
          width="75%"
          {...navBar}
        />
        <clipPath id="browser-icon-browser-text-clip">
          <rect width="70%" x={navBarText.x} y="6" height="28" />
        </clipPath>
        <text
          clipPath="url(#browser-icon-browser-text-clip)"
          mask="url(#browser-icon-c)"
          fontSize={navBarText.fontSize}
        >
          {browserUrl}
        </text>
        <circle fill="#CECECE" mask="url(#browser-icon-c)" {...circles[0]} />
        <circle fill="#CECECE" mask="url(#browser-icon-c)" {...circles[1]} />
        <circle fill="#CECECE" mask="url(#browser-icon-c)" {...circles[2]} />
      </g>
    </svg>
  );
};

Browser.propTypes = {
  circles: PropTypes.array,
  className: PropTypes.string,
  domain: PropTypes.string,
  height: PropTypes.number,
  navBar: PropTypes.object,
  navBarText: PropTypes.object,
  subDomain: PropTypes.string,
  width: PropTypes.number,
};

Browser.defaultProps = {
  circles: [
    { cx: 16, cy: 20, r: 6 },
    { cx: 33, cy: 20, r: 6 },
    { cx: 50, cy: 20, r: 6 },
  ],
  height: 214,
  navBar: {
    height: 28,
    rx: 3,
    x: 66,
    y: 6,
  },
  navBarText: {
    x: 75,
    y: 23,
    fontSize: 12,
  },
  subDomain: I18n.t('form.onboarding.placeholder.subdomain_name'),
  width: 313,
};

export default Browser;
